import { get } from "lodash";

const linkedPoleIds = (supervisor) => {
  const poles = get(supervisor, "poles");
  if (!Array.isArray(poles)) return null;
  return poles.filter((pole) => pole && pole.id).map((pole) => pole.id);
};

export const poleIdsForSupervisors = (supervisors = []) => {
  const poleIds = [];
  const seenPoleIds = new Set();
  const supervisorIdsWithoutPole = [];
  const unresolvedSupervisorIds = [];

  supervisors.forEach((supervisor) => {
    const supervisorId = get(supervisor, "id");
    const poleIdsForSupervisor = linkedPoleIds(supervisor);
    if (!supervisorId || !poleIdsForSupervisor) {
      unresolvedSupervisorIds.push(supervisorId);
      return;
    }
    if (!poleIdsForSupervisor.length) {
      supervisorIdsWithoutPole.push(supervisorId);
      return;
    }
    poleIdsForSupervisor.forEach((poleId) => {
      if (seenPoleIds.has(poleId)) return;
      seenPoleIds.add(poleId);
      poleIds.push(poleId);
    });
  });

  return { poleIds, supervisorIdsWithoutPole, unresolvedSupervisorIds };
};

export const resolveSupervisorAssignment = (
  selectedIds = [],
  supervisors = [],
) => {
  const resolved = poleIdsForSupervisors(supervisors);
  const returnedIds = new Set(
    supervisors
      .filter((supervisor) => supervisor && supervisor.id)
      .map((supervisor) => supervisor.id),
  );
  const missingSupervisorIds = selectedIds.filter(
    (supervisorId) => !returnedIds.has(supervisorId),
  );
  const canAssign =
    missingSupervisorIds.length === 0 &&
    resolved.unresolvedSupervisorIds.length === 0;

  return { ...resolved, missingSupervisorIds, canAssign };
};
